module.exports = __webpack_public_path__ + "img/img10.57c3f73a.png";